export enum VerificationTypeEnum {
  SIGNUP = "signup",
  SIGNIN = "signin",
  RESET_PASSWORD = "reset_password",
}


export enum UserAttemptType {
  INVALID_PASSWORD_ATTEMPT = "invalid_password_attempt",
  RESET_PASSWORD_VERIFICATION_ATTEMPT = "reset_password_verification_attempt",
  SIGNUP_VERIFICATION_ATTEMPT = "signup_verification_attempt",
}